import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppComponent } from 'src/app/app.component';
import { UtilsService } from 'src/app/services/utils.service';
import { AppSettings } from 'src/app/app.settings';
import { RecaptchaComponent } from 'ng-recaptcha';
import { crossMsg, drOption } from '@robisoft/cross-library';
import { CrossCpService } from 'src/app/cross-utils/services/cross-cp.service';
import { SendFormReq } from 'src/app/models/SendForm';
import { PrivacyComponent } from 'src/app/cross-utils/privacy/privacy.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-richiedi-info',
  templateUrl: './richiedi-info.component.html',
  styleUrls: ['./richiedi-info.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class RichiediInfoComponent implements OnInit, OnDestroy {

  isSocio: boolean;
  richiestaInviata: boolean;
  error: string;
  isLoading: boolean;
  visualizzaNomi: boolean;

  App: string;

  prenotaNome: string;
  prenotaEmail: string;
  prenotaMobile: string;
  prenotaMsg: string;
  privacy: boolean;
  errorMessage: string;

  captcha: string;
  @ViewChild('recaptcha') captchaElem: RecaptchaComponent;
  sub: Subscription;
  firstRun: boolean;

  constructor(public app: AppComponent,
    private cpService: CrossCpService,
    private dialog: MatDialog,
    public utils: UtilsService) {
    this.isSocio = false;
    this.richiestaInviata = false;
    this.error = '';
    this.isLoading = false;
    this.visualizzaNomi = false;
    this.App = AppSettings.App;
    this.prenotaNome = '';
    this.prenotaEmail = '';
    this.prenotaMobile = '';
    this.prenotaMsg = '';
    this.privacy = false;
    this.errorMessage = '';
    this.captcha = '';
    this.sub = new Subscription();
    this.firstRun = false;
  }

  ngOnInit(): void {

  }

  ngOnDestroy(): void {

  }

  resolved(captchaResponse: string) {
    this.captcha = captchaResponse;
    this.checkForm();
  }

  async invia() {
    this.errorMessage = '';
    this.checkForm();

    if (this.errorMessage === '') {
      const req = new SendFormReq();
      req.store = this.app.store;
      req.responseCaptcha = this.captcha;
      req.emailModel = 'richiedi-info';
      req.emailModel2 = 'richiesta-inoltrata';
      req.lang = 'it';
      req.fields = [];
      req.fields.push(new drOption(this.prenotaNome, 'Nome'));
      req.fields.push(new drOption(this.prenotaEmail, 'Email'));
      req.fields.push(new drOption(this.prenotaMobile, 'Cellulare'));
      req.fields.push(new drOption(this.prenotaMsg, 'Messaggio'));
      const resp = await this.cpService.sendForm(AppSettings.API_ENDPOINT, req);
      if (resp.error === '') {
        this.richiestaInviata = true;
        this.prenotaNome = '';
        this.prenotaEmail = '';
        this.prenotaMobile = '';
        this.prenotaMsg = '';
        this.privacy = false;
        this.errorMessage = '';
        this.captcha = '';
        this.captchaElem.reset();
        this.app.onMessage.emit(new crossMsg('gotoCart', {
          store: this.app.store,
        })
        );
        this.app.onMessage.emit(new crossMsg('ShowToastMessage', {
          message: 'Messaggio inviato con successo',
        }));
      }
    }
  }


  onInviaRichiesta() {

  }


  public gotoLogin(): void {
    this.app.onMessage.emit(new crossMsg('gotoLogin', {
      store: this.app.store,
    })
    );
    //this.router.navigateByUrl('/login?store=' + this.store);
  }

  public gotoSocioPage(): void {
    this.app.onMessage.emit(new crossMsg('gotoSocioPage', {
      store: this.app.store,
    })
    );
    //this.router.navigateByUrl('/richiesta-socio-golf?store=' + this.store);
  }

  public checkForm() {
    if (this.prenotaNome === '')
      this.errorMessage = 'Inserisci il tuo nome';
    else if (this.prenotaEmail === '')
      this.errorMessage = 'Inserisci la tua email';
    else if (this.prenotaMobile === '')
      this.errorMessage = 'Inserisci il tuo numero di cellulare';
    else if (this.privacy === false)
      this.errorMessage = 'Devi accettare le condizioni';
    else if (this.captcha === '')
      this.errorMessage = 'Spunta il re-captcha';
    else
      this.errorMessage = '';
  }

  openUrl(url: string) {
    let link = '';
    if (!url){
      url = 'https://opengolf.it/it/privacy-policy?header=no';
    }
    if (url.startsWith('http'))
      link = url;
    else
      link = AppSettings.URL + '/img/' + this.app.store + '/' + url;

    const dialogRef = this.dialog.open(PrivacyComponent, {
      data: {
        privacyUrl: link
      },
      panelClass: 'full-screen'
    });

  }


}
